import React from 'react';
import { Flex, Text, OutlineButton } from '@cko/primitives';
import styled from 'styled-components';
import { StyledLoading } from '../StyledHelperComponents';

const StateViewContainer = styled(Flex)`
  width: 100%;
  height: 430px;
  padding: var(--layout-soybean) var(--layout-stamp);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--layout-soybean);
  flex-shrink: 0;
`;

const FormattedText = styled(Text)`
  color: var(--control-text-primary);
  font: var(--body-xs-medium);
`;

const ErrorText = styled(Text)`
  color: var(--control-text-primary);
  font: var(--body-xs-medium);
`;

interface AccountSelectorNoResultsProps {
  resetSearch: () => void;
}

interface AccountSelectorQueryErrorProps {
  refetch: () => void;
}

export const AccountSelectorLoading = () => {
  return (
    <StateViewContainer data-testid="dialog-loading">
      <Flex alignItems="center" justifyContent="center">
        <StyledLoading />
      </Flex>
    </StateViewContainer>
  );
};

export const AccountSelectorNoResults = ({ resetSearch }: AccountSelectorNoResultsProps) => {
  return (
    <StateViewContainer data-testid="dialog-no-results">
      <FormattedText>No Results Found.</FormattedText>
      <OutlineButton data-testid="clear-search-button" onClick={resetSearch}>
        Clear Search
      </OutlineButton>
    </StateViewContainer>
  );
};

export const AccountSelectorQueryError = ({ refetch }: AccountSelectorQueryErrorProps) => {
  return (
    <StateViewContainer data-testid="dialog-error">
      <ErrorText>Error Fetching Results</ErrorText>
      <OutlineButton data-testid="error-retry-button" onClick={refetch}>
        Retry
      </OutlineButton>
    </StateViewContainer>
  );
};
